"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : LOADER : STYLES--------------- ++++++++++ */


var _default = {
  barelement: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '20%',
    height: function height(props) {
      return (0, _index.replacePXinStringWithEM)("calc(".concat(props.y, " + 36px)"));
    },
    '& .bar': {
      width: (0, _index.pxToEm)(25),
      height: '100%',
      background: function background(props) {
        return props.color;
      }
    },
    '& .value, .label': {
      fontSize: (0, _index.pxToEm)(12)
    },
    '& .label': {
      marginTop: (0, _index.pxToEm)(5),
      color: 'rgb(130, 149, 186)'
    },
    '& .value': {
      marginBottom: (0, _index.pxToEm)(5)
    }
  }
};
exports.default = _default;